<template>
  <div class="text-small">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col cols="10">
        <div style="margin-bottom: 2px;" tabindex="0" ref="tituloDetCita">
          <em class="cita_svg iconAgendaDetalle"></em>
          <strong style="color:rgb(19 71 103);font-size: 17px;margin-left: 10px;" :title="datosDetalle.idCita"> Detalles de la cita </strong>
        </div>
      </b-col>

      <b-col cols="2">
        <div class="d-flex justify-content-center" style="    height: 80%;">
          <div :style="'background-color:' + datosDetalle.colorEstatusSDI +
                    ';height:100%;width: 12%; position: relative; border-radius: 10px 1px 1px 10px; ' +
                     'border:1px solid rgb(120 115 115)'">
            <strong :style="'color:' + datosDetalle.colorEstatusSDI ">.</strong>
          </div>
          <div class="flexbox" :style=" datosDetalle.color + '; border:1px solid rgb(120 115 115)' ">
            <strong  :style="'color:' + datosDetalle.color "> {{datosDetalle.estatusCita}}</strong>
          </div>
        </div>
        <div v-if="datosDetalle.promocionesCita !== null && datosDetalle.promocionesCita.length === 1" class="d-flex justify-content-center mt-2">
          <em class="estrella_completa"></em><span style="color:#17A2B8; font-weight: bolder">CITA CON PROMO</span>
        </div>

        <div v-if="datosDetalle.promocionesCita !== null && datosDetalle.promocionesCita.length === 1" class="d-flex justify-content-center">
          <strong>{{datosDetalle.promocionesCita[0].nombrePromocion}}</strong>
        </div>
        <div  v-if="datosDetalle.promocionesCita !== null && datosDetalle.promocionesCita.length > 1"  class="d-flex justify-content-center">
          <strong>Múltiples promos</strong>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">

        <CardPacienteAgenda
            :datosDetalle="datosDetalle"
            :origen="origen"
            :citaIsOverbooking="datosDetalleOverbooking != undefined && datosDetalleOverbooking != null"
        ></CardPacienteAgenda>


        <b-col v-if="datosDetalleOverbooking != undefined && datosDetalleOverbooking != null" class="mt-3">
          <strong style="color:#0069aa;font-size: 17px;">
            <span v-if="datosDetalleOverbooking.citaSobreAsignada">Paciente sobre agendado</span>
            <span v-else>Paciente Original</span>
          </strong>

          <b-card class="borde-azul-simple pb-0 " @click="cambiarConsultarDetallePorPaciente(datosDetalleOverbooking)">
                <div style="color:#0069aa;font-size: 15px;cursor:pointer;"
                    :title="datosDetalleOverbooking.idCita">
                  {{datosDetalleOverbooking.nombrePaciente}}
                  <span v-if="datosDetalleOverbooking.esPacienteVIP" class="ml-1">MISD</span>
                </div>
                <div class="mt-1" style="font-size: 12px;">
                  Motivo: Priorización de pacientes
                </div>
          </b-card>
        </b-col>

        <b-popover 
          v-if="origen != 4" target="popover-movimientos-cita" triggers="click blur" placement="bottomright" style="max-width: 200px">

          <div style="width: 160px;text-align: center;font-size: 16px;">
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-show=" ( activarIniciarSesion(datosDetalle) && fechaLlegada == null ) "
                      @click.prevent="activarModalContactoPaciente(datosDetalle)"
            >
              Asignar hora de llegada
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-show=" ( activarIniciarSesion(datosDetalle) && fechaLlegada != null ) "
                      @click="iniciarSesion(datosDetalle)"
            >
              Iniciar sesión
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if=" activarConfirmarCita(datosDetalle) && datosDetalle.isCitaConfirmada == false "
                      @click.prevent="showDialogConfirmarCita = true"
            >
              Confirmar cita
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="activarCancelarCita(datosDetalle)"
                      @click.prevent="cancelarCita(datosDetalle)"
            >
              Cancelar cita
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="activarReagendar(datosDetalle)"
                      @click.prevent="reagendarCita(datosDetalle)"
            >
              Reagendar cita
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="activarReasignarDoctor(datosDetalle)"
                      @click.prevent="reasignarDoctor(datosDetalle)"
            >
              Reasignar doctor
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="activarSobreAgendar(datosDetalle)"
                      @click.prevent="sobreAgendar(datosDetalle)"
            >
              Sobre agendar
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="pintarCitaSobreAgendable(datosDetalle) && (datosDetalle.idMovimientoAgendable === 8 || datosDetalle.idMovimientoAgendable === null) && datosDetalle.citaSobreAsignada === false"
                      @click.prevent="sobreAgendable(datosDetalle)"
            >
              Habilitar sobre-agendamiento
            </b-button>
            <b-button variant="outline-ligth" style="padding: 0px;" class="filtrosCita"
                      v-if="$localStorageService.can('sobreAgendamiento') && datosDetalle.idMovimientoAgendable === 1 && datosDetalle.citaSobreAsignada === false"
                      @click.prevent="deshabilitarSobreAgendable(datosDetalle)"
            >
              Deshabilitar sobre-agendamiento
            </b-button>
          </div>
        </b-popover>



      </b-col>





      <b-col cols="9">
        <b-tabs class="noAlTope">

          <b-tab title="Información de cita">
            <div class="mt-2">
              <strong style="color:#0069aa"> Información de la cita </strong>
            </div>
            <div style="margin-top: 10px;">
              <b-table-simple>
                <b-tbody class="text-left">

                  <b-tr>
                    <b-th>Fecha</b-th>
                    <b-td
                    >{{ datosDetalle.fechaCita | formatoFecha }}
                      {{
                        datosDetalle.horaInicioCasilla | formatoHoraDeHora
                      }}
                    </b-td
                    >
                  </b-tr>
                  <b-tr>
                    <b-th>Horario</b-th>
                    <b-td>
                      De
                      {{ datosDetalle.horaInicioCasilla | formatoHoraDeHora }}
                      a
                      {{
                        datosDetalle.horaFinCasilla | formatoHoraDeHora
                      }}
                    </b-td
                    >
                  </b-tr>
                  <b-tr>
                    <b-th>No. sillón</b-th>
                    <b-td>{{ datosDetalle.sillon }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Motivo de cita</b-th>
                    <b-td>{{ datosDetalle.motivoCitaTag }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Tratamiento(s)</b-th>
                    <b-td>
                      <div v-if="!loadercito">
                        <ul v-if="listaTratamientosCita.length > 1 && show" style="display: inline-table;  margin-bottom: -3px;">
                          <li  v-for="tc in listaTratamientosCita" :key="tc.idTratamiento"
                          style=" margin-bottom: 5px;"
                          >{{ tc.nombreTratamiento }}</li>
                        </ul>
                      <div v-else-if="!show && listaTratamientosCita[0] !== null && listaTratamientosCita[0] !== undefined">{{listaTratamientosCita[0].nombreTratamiento}}</div>

                        <div v-if="listaTratamientosCita.length > 1" style=" position: relative;  margin-left: 70%; margin-top: -17px;">
                          <span v-if="show" @click="show = !show" style="color: #0069aa; cursor: pointer">ver menos...</span>
                          <span v-else @click="show = !show" style="color: #0069aa; cursor: pointer">ver mas...</span>
                        </div>
                      </div>
                      <b-spinner v-else small variant="info"></b-spinner>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Doctor</b-th>
                    <b-td
                    >{{ datosDetalle.idDoctor }}-{{
                        datosDetalle.nombreDoctor
                      }}
                      ({{ datosDetalle.nombreEspecialidadDoctor }})
                    </b-td
                    >
                  </b-tr>
                  <b-tr>
                    <b-th>Plan</b-th>
                    <b-td>
    
                      <template v-if="this.filtros.options.planes !== undefined && this.filtros.options.planes !== null">
                           <span v-for="planImg in datosDetalle.idsPlanes" :key="planImg">
                          
                             <b-list-group>
                                <b-list-group-item v-if="obtenerImagenPlan(planImg) !== null">
                                  <div style="display: inline">
                                     <img alt="detalleCita" :src="'data:image/png;base64, '+ obtenerImagenPlan(planImg).img" style="width: 50px" v-if="obtenerImagenPlan(planImg).img"/>
                                     <div class="d-flex justify-content-start align-items-center">
                                      <p class="p-0 m-0 mr-1">{{ obtenerImagenPlan(planImg).titulo}}</p>
                                      <div class="text-center" v-b-tooltip.hover.topright.v-light title="Este plan no requiere herramientas de diagnóstico" v-if="buscarPlanSinHerramientas(obtenerImagenPlan(planImg).id)" style="background-color: #E5E7E7; border-radius: 50px; color: #7E7E7E; padding: 2px 5px; font-weight: 600;">
                                        <p class="p-0 m-0">PRESUNTIVO</p>
                                      </div>
                                     </div>
                                   </div>
                                </b-list-group-item>
                             </b-list-group>

                           </span>
                      </template>
                    </b-td>
                  </b-tr>
                  <b-tr>
       
                    <b-th>Persona que registro</b-th>
                    <b-td>{{ datosDetalle.usuarioAlta }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Medio de contacto</b-th>
                    <b-td>{{ datosDetalle.canalOrigen }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Tipo de cita </b-th>
                    <b-td>{{ datosDetalle.citaAdministrativa ? "Administrativa" : "Normal" }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th>Observaciones</b-th>
                    <b-td>
                      <div class="scrollable-container-observaciones no-horizontal-scroll">
                        <b-list-group class="word-break" v-for="(com, index) in datosDetalle.observaciones"
                                      :key="index">
                          <b-list-group-item class="word-break">
                            <span v-if="com.usuarioAlta !== null">({{ com.usuarioAlta }}) </span>
                            <span v-if="com.fechaAlta !== null">({{ com.fechaAlta | formatoFechaHoraTexto }}) </span>
                            <span>{{ com.observacion }}</span>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </div>
          </b-tab>

          <b-tab title="Detalle historial de citas">
            <HistorialCitasAgenda :idPaciente.sync="datosDetalle.idPaciente"></HistorialCitasAgenda>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>






    <b-modal
        v-model="showDialogConfirmarCita"
        id="modConfirmarCita"
        title="¿Deseas confirmar la cita?"
        scrollable
    >
      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitConfirmarCita"
        >Aceptar
        </b-button
        >
        <b-button
            variant="outline-danger"
            @click="showDialogConfirmarCita = false"
        >Cancelar
        </b-button>
      </template>
    </b-modal>


    <b-modal
        size="lg"
        v-model="showDialogCancelarCita"
        id="modCancelarCita"
        title="¿Deseas cancelar la cita?"
        scrollable
        no-close-on-backdrop
        hide-header
        hide-footer
    >
    <b-row>
      <b-col cols="10">
        <div style="margin-bottom: 2px;">
          <em class="close_equis_svg" style="width: 16px"></em>
          <strong style="color:rgb(19 71 103);font-size: 15px;margin-left: 10px;">Cancelar cita </strong>
        </div>
      </b-col>
    </b-row>



      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(cancelarCitaServ)" style="font-size: 12px;">
          <validation-provider
              name="MotCancelar"
              :rules="{ required: true }"
              v-slot="validationContext"
          >
            <b-form-group class="mt-4">
              <label>Motivo de cancelación</label>
              <validacion/>
              <v-select
                  style="width: 100%"
                  :options="listaMotivosCancelacion"
                  v-model="datosCancelarCita.motivoCancelacion"
                  :reduce="(variable) => variable.id"
                  label="descripcion"
                  placeholder="Selecciona el motivo de cancelación"
              >
                <span slot="no-options">No hay valores disponibles</span>
              </v-select>
              <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
              />
            </b-form-group>
          </validation-provider>

          <validation-provider
              name="DescCancelar"
              :rules="{ required: true }"
              v-slot="validationContext"
          >
            <b-form-group class="mt-4">
              <label>Descripción de cancelación</label>
              <validacion/>
              <b-textarea
                  v-model="datosCancelarCita.descripcionCancelacion"
                  placeholder="Descripción de cancelación"
              ></b-textarea>
              <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
              />
            </b-form-group>
          </validation-provider>

          <b-button
              ref="submitCancelarCita"
              type="submit"
              style="visibility: hidden"
          ></b-button>
        </b-form>
      </validation-observer>
      <div style="text-align: center;">
        <b-button pill
                  variant="primary" @click="submitCancelarCita"
                  style="margin-right: 60px; background-color: rgb(0, 105, 170);"
        >Guardar
        </b-button
        >
        <b-button pill
            @click="showDialogCancelarCita = false"
        >Cancelar
        </b-button>
      </div>
      <template v-slot:modal-footer>

      </template>
    </b-modal>


    <b-modal
        v-model="showDialogIniciarSession"
        id="modIniciarSesion"
        title="¿Deseas iniciar la sesión?"
        scrollable
    >

      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(iniciarSesionServ)">
          <p v-if="!pacienteQuiereHerramientas && pacienteQuiereHerramientas != null" style="color: rgb(161, 23, 23)">El paciente solicitó no tomarle herramientas.</p>
          <validation-provider
              name="ReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="
                !citaSeleccionada.pacienteEsNino &&
                !citaSeleccionada.especialistaNino &&
                !citaSeleccionada.citaEmbajador &&
                noExistePTIVigente
              "
          >
            <label>¿Requiere herramientas?</label>
            <validacion/>
            <b-form-group>
              <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaSINOFiltro"
                  :filterable="false"
                  @search="filtrolListaSINO"
                  v-model="datosIniciarSesion.herramientas"
                  :reduce="(variable) => variable.valor"
                  label="etiqueta"
                  placeholder="¿La sesión requiere herramientas?"
                  id="idReqHerramientas"
                  name="nmReqHerramientas"
              >
                <span slot="no-options">No hay valores disponibles</span>
              </v-select>
              <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
              />
            </b-form-group>
          </validation-provider>

          <validation-provider
              name="MotReqHerr"
              :rules="{ required: true }"
              v-slot="validationContext"
              v-if="
                !datosIniciarSesion.herramientas &&
                !citaSeleccionada.especialistaNino &&
                !citaSeleccionada.citaEmbajador &&
                noExistePTIVigente
              "
          >
            <label>Motivo para no requerir herramientas</label>
            <validacion/>
            <b-form-group>
              <v-select
                  style="width: 100%"
                  :clearable="false"
                  :options="listaMotivosHerramientasFiltro"
                  :filterable="false"
                  @search="filtrolListaMotivosHerramientas"
                  v-model="datosIniciarSesion.idMotivoHerramienta"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Motivo para no requerir herramientas"
                  id="idMotReqHerramientas"
                  name="nmMotReqHerramientas"
              >
                <span slot="no-options">No hay valores disponibles</span>
              </v-select>
              <validacion
                  :texto="
                    validationContext.errors[0]
                      ? validationContext.errors[0]
                      : ' '
                  "
              />
            </b-form-group>
          </validation-provider>

          <b-button
              ref="submitIniciarSesion"
              type="submit"
              style="visibility: hidden"
          ></b-button>
        </b-form>
      </validation-observer>

      <template v-slot:modal-footer>
        <b-spinner small v-if="loadingExistePTI"></b-spinner>
        <b-button
            variant="outline-primary"
            @click="submitIniciarSesion"

        >Aceptar
        </b-button
        >
        <b-button
            variant="outline-danger"
            @click="showDialogIniciarSession = false"
        >Cancelar
        </b-button>
      </template>
    </b-modal>



    <b-modal
        v-model="modalReasignarDoctor"
        id="modalReasignarDoctor"
        title="Reasignar doctor"
        scrollable
    >
      <validation-observer ref="observ" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(guardarReasignarDoctor)">
          <b-row>
            <b-col>
              <validation-provider
                  :rules="{ required: true }"
                  v-slot="errors"
              >
                <label>Doctor</label>
                <validacion/>
                <b-form-group>
                  <v-select
                      style="width: 100%"
                      :options="listaDoctores"
                      v-model="datosFormularioReasignar.idDoctor"
                      :reduce="(variable) => variable.id"
                      label="nombre"
                      placeholder="Selecciona un doctor (*)"
                  >
                    <span slot="no-options">No hay doctores disponibles</span>
                  </v-select>
                  <validacion
                      :texto="errors.errors[0] ? errors.errors[0] : ' '"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-button
              ref="submitReasignarDoctor"
              type="submit"
              style="visibility: hidden"
          ></b-button>
        </b-form>
      </validation-observer>

      <b-row>
        <b-col cols="12">
          <strong>Paciente:</strong>
          {{ datosFormularioReasignar.nombrePaciente }}
        </b-col>
        <b-col cols="12">
          <strong>Fecha de nacimiento:</strong>
          {{ datosFormularioReasignar.fechaNacimientoCompleta }}
        </b-col>
        <b-col cols="6">
          <strong>Fecha:</strong>
          {{ datosFormularioReasignar.fechaCita | formatoFecha }}
          {{ datosFormularioReasignar.horaInicioCasilla | formatoHoraDeHora }}
        </b-col>
        <b-col cols="6">
          <strong>Horario:</strong>
          Entre
          {{ datosFormularioReasignar.horaInicioCasilla | formatoHoraDeHora }}
          y
          {{ datosFormularioReasignar.horaFinCasilla | formatoHoraDeHora }}
        </b-col>

        <b-col cols="6">
          <strong>Status:</strong>
          {{ datosFormularioReasignar.estatusCita }}
        </b-col>

        <b-col
            cols="6"
            v-if="
              listaTratamientosCita !== undefined &&
              listaTratamientosCita.length > 0
            "
        >
          <strong>Tratamiento:</strong>
          <span
              v-for="tratamiento in listaTratamientosCita"
              v-bind:key="tratamiento.idTratamiento"
          >
              {{ tratamiento.nombreTratamiento }}<br/>
            </span>
        </b-col>

        <b-col cols="12">
          <strong>Observaciones:</strong>
          {{ datosFormularioReasignar.comentario }}
        </b-col>
      </b-row>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitReasignarDoctor"
        >Guardar
        </b-button
        >
        <b-button
            variant="outline-danger"
            class="botones"
            @click="modalReasignarDoctor = false"
            size="lg"
            style="margin-left: 10px"
        >Cancelar
        </b-button>
      </template>
    </b-modal>


    <HojaBienvenida
        :nombrePaciente="nombrePaciente"
        :tagMotivoCita="nombreTagMotivoCita"
        :idCita="idCita"
        :idTipoDenticion="idTipoDenticion"
        :nombreTutor="nombreTutor"
    />

    <b-modal
        v-model="modalDatosContacto"
        id="modalDatosContacto"
        title="Asignar hora de llegada"
        size="lg"
        scrollable
        hide-footer
        hide-header-close
        centered
    >
        <DatosContactoHoraLlegada :id-paciente="datosDetalle.idPaciente" :idPacientePadre="datosDetalle.idPacientePadre" @continuarProceso="asignarHoraLlegadaPaciente()" @cancel="modalDatosContacto = false"/>
    </b-modal>


  </div>
</template>

<script>
import HistorialCitasAgenda from "@/components/NuevaAgenda/HistorialCitasAgenda";
import CardPacienteAgenda from "@/components/NuevaAgenda/CardPacienteAgenda";
import DatosContactoHoraLlegada from "@/components/NuevaAgenda/DatosContactoHoraLlegada.vue";
export default {
  name: "DetalleDeCita",
  components: {DatosContactoHoraLlegada, CardPacienteAgenda, HistorialCitasAgenda},
  props:{
    datosDetalleProp: Object,
    datosDetalleOriginal: Array,
    datosDetalleOverbookingProp: Object,
    filtros: Object,
    pacienteSeleccionado: Object,
    fechaLlegada: Boolean,
    listaSINOFiltro: Array,
    datosBusqueda:Object,
    origen: {
      type: Number,
      default: 1
    }
  },
  data:() =>({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaMotivosCancelacion: [],
    pacienteQuiereHerramientas: true,
    showDialogConfirmarCita: false,
    showDialogCancelarCita: false,
    datosCancelarCita: {},
    showDialogIniciarSession: false,
    datosIniciarSesion: {},
    loadingExistePTI: false,
    modalReasignarDoctor: false,
    datosFormularioReasignar: [],
    listaDoctores: [],
    nombrePaciente: null,
    nombreTagMotivoCita: null,
    idTipoDenticion: null,
    nombreTutor: null,
    idCita: null,
    listaMotivosHerramientasFiltro: [],
    listaMotivosHerramientas: [],
    listaTratamientosCita: [],
    show: false,
    loadercito: true,
    detalleCita: null,
    datosDetalleOverbooking: null,
    datosDetalle: null,

    datosHoraLlegada: null,
    modalDatosContacto: false,
    planesSinHerramientas: [],
  }),
  computed:{
     buscarPlanSinHerramientas() {
      return (planId) => {
        return this.planesSinHerramientas.find(a => a.idPlan === planId) || null;
      };
   }
  },
  created(){
    this.debug = this.$localStorageService.getDebug();
    this.datosDetalle = this.datosDetalleOriginal[0];
    this.datosDetalleOverbooking = this.datosDetalleOriginal[1];
    this.llenarMotivosHerramientas();
    this.traerTratamientosCita();
    this.traerDetalleCita();
   
    
  },
   methods:{
    traerDetalleCita(){
      const citas = [];
      this.datosDetalleOriginal.forEach(cita => {
        citas.push(cita.idCita);
      });
      const parametros = {idCitas: citas}
       this.$http
           .post(
               this.$api + "agenda/obtenerDetalleCita", parametros
           ).then((response) => {
            const respuesta = response.data.data;
         this.datosDetalle.idPaciente = respuesta[0].idPaciente;
         this.datosDetalle.comentario = respuesta[0].comentario;
         this.datosDetalle.comentarioFijo = respuesta[0].comentarioFijo;
         this.datosDetalle.fechaLlegada = respuesta[0].fechaLlegada;
         this.datosDetalle.celular = respuesta[0].celular;
         this.datosDetalle.idPaciente = respuesta[0].idPaciente;
         this.datosDetalle.idPacientePadre = respuesta[0].idPacientePadre;
         this.datosDetalle.nombrePaciente = respuesta[0].nombrePaciente;
         this.datosDetalle.pacienteEsNino = respuesta[0].pacienteEsNino;
         this.datosDetalle.sexo = respuesta[0].sexo;
         this.datosDetalle.usuarioAlta = respuesta[0].usuarioAlta;
         this.datosDetalle.estatusHc = respuesta[0].estatusHc;
         this.datosDetalle.esPacienteVIP = respuesta[0].esPacienteVIP;

         if (this.datosDetalleOriginal.length > 1) {
            this.datosDetalleOverbooking.idPaciente = respuesta[1].idPaciente;
            this.datosDetalleOverbooking.comentario = respuesta[1].comentario;
            this.datosDetalleOverbooking.fechaLlegada = respuesta[1].fechaLlegada;
            this.datosDetalleOverbooking.celular = respuesta[1].celular;
            this.datosDetalleOverbooking.idPaciente = respuesta[1].idPaciente;
            this.datosDetalleOverbooking.idPacientePadre = respuesta[1].idPacientePadre;
            this.datosDetalleOverbooking.nombrePaciente = respuesta[1].nombrePaciente;
            this.datosDetalleOverbooking.pacienteEsNino = respuesta[1].pacienteEsNino;
            this.datosDetalleOverbooking.sexo = respuesta[1].sexo;
            this.datosDetalleOverbooking.usuarioAlta = respuesta[1].usuarioAlta;
            this.datosDetalleOverbooking.estatusHc = respuesta[1].estatusHc;
            this.datosDetalleOverbooking.esPacienteVIP = respuesta[1].esPacienteVIP;
          }

          if(this.datosDetalle.idsPlanes.length > 0){
            this.obtenerSoloPlanesActivos();
            
          }
           }).finally(()=> {
             this.loadercito = false;
           })
    },

    obtenerSoloPlanesActivos(){
      const parametros = {
        idPaciente:  this.datosDetalle.idPaciente
      };

      this.$http.post(this.$api + "paciente/estadoPlanesPaciente", parametros)
      .then((response) => {
         const respuesta = response.data.data;
        
         const planesActivos = respuesta.filter(item => item.planActivo);
        const idPlanes = planesActivos.map(item => item.idPlan);

         this.obtenerPlanSinHerramientas(idPlanes);
           }).finally(()=> {
             this.loadercito = false;
           })
    },


    obtenerPlanSinHerramientas(idPlanes){
      const parametros = {
        idPlanes: idPlanes
      };

      this.$http.post(this.$api + "planPaciente/obtener/planesSinHerramientas", parametros)
      .then((response) => {
         const respuesta = response.data.data;
         this.planesSinHerramientas = respuesta;
           }).finally(()=> {
             this.loadercito = false;
           })
    },

     traerTratamientosCita(){
      this.datosDetalle.idCita
      const parametros = {idCita: this.datosDetalle.idCita}
       this.$http
           .post(
               this.$api +
               "agenda/obtenerTratamientosCita", parametros
           ).then((response) => {
         this.listaTratamientosCita = response.data.data;
           }).finally(()=> {
             this.loadercito = false;
           })
    },
     obtenerImagenPlan(idPlan) {
       const planImg = this.filtros.options.planes.find(it=>it.id===idPlan);
      if (planImg !== undefined && planImg !== null) {
        return planImg;
      }
      return null;
    },
    filtrolListaSINO(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.listaSINOFiltro = this.listaSINO.filter((em) => {
        return em.etiqueta.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },


     filtrolListaMotivosHerramientas(busqueda, loading) {
       loading(true);
       let seach = busqueda.trim();
       this.listaMotivosHerramientasFiltro =
           this.listaMotivosHerramientasFiltro.filter((em) => {
             return em.nombre.toLowerCase().includes(seach.toLowerCase());
           });
       loading(false);
     },

     llenarMotivosHerramientas() {
       this.$http
           .get(this.$api + "catalogos/listaMotivosHerramientas")
           .then((response) => {
             if (response.status === 200) {
               this.listaMotivosHerramientas = response.data.data
                   .map((it) => {
                     return {
                       id: it.idMotivo,
                       nombre: it.descripcion,
                     };
                   })
                   .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
               this.listaMotivosHerramientasFiltro = this.listaMotivosHerramientas;
             }
           })
           .catch((error) => {
             console.error(error);
           });
     },

     // Esta funcion se activa al dar click asignarHoraLlegadaPaciente
    activarModalContactoPaciente(datosCita){
      this.datosHoraLlegada = datosCita;

      if (
          (datosCita.pacienteEsNinoNino || datosCita.pacienteEsMixto) &&
          datosCita.idPacientePadre === null
      ) {
        this.loading = false;
        this.$swal
            .fire({
              icon: "info",
              title: "Aviso",
              text: "El paciente es menor de edad, es necesario agregar un tutor",
              confirmButtonColor: "#0e6ba9",
              cancelButtonColor: "#8e8e8e",
              confirmButtonText: "OK",
              cancelButtonText: "CANCELAR",
              showCancelButton: true,
            })
            .then((aceptar) => {
              if (aceptar.value) {
                this.$router.push({
                  name: "HistoriaNinoLink",
                  params: {
                    idPaciente: this.$global.encriptar(datosCita.idPaciente),
                    idClinica: this.$global.encriptar(datosCita.idClinica),
                  },
                });
                localStorage.abrirAgenda = true;
              }
            });
        return false;
      }

      this.modalDatosContacto = true;
    },

    asignarHoraLlegadaPaciente() {
      this.loading = true;
      this.idCita = this.datosHoraLlegada.idCita;
      const params = {
        idCita: this.datosHoraLlegada.idCita
      }
      this.$http
          .put(
              this.$api +
              "cita/registrar/horadellegadapaciente", params )
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.aplicaHojaBienvenida == true) {
                this.$swal({
                  icon: "success",
                  text:
                      response.data.data.mensaje,
                  confirmButtonText: "Enterado",
                  showConfirmButton: true,
                  allowOutsideClick: false,
                });
              } else {
                this.$swal.fire({
                  icon: "success",
                  title: "Aviso",
                  text: response.data.data.mensaje,
                });
              }
              this.fechaLlegada = true;
              //  this.$emit('buscarAgenda', false)

            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrio un error al realizar el registro de la hora de llegada del paciente",
            });
          })
          .finally(() => {
            this.fechaLlegada = true;
            this.modalDatosContacto = false;
            this.loading = false
          });
    },
    verHojaBienvenida() {
      this.loading = true;

      this.$http
          .get(
              this.$api + "cita/obtener/datoshojabienvenida?idCita=" + this.idCita
          )
          .then((response) => {
            let datos = response.data.data;
            this.nombrePaciente = datos.nombrePaciente;
            this.nombreTagMotivoCita = datos.tagMotivoCita;
            this.idTipoDenticion = datos.idTipoDenticion;
            this.nombreTutor = datos.nombreTutor;
            this.idCita = this.idCita;

            this.$bvModal.show("modal-hoja-bienvenida");
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    submitIniciarSesion() {
      this.$refs.submitIniciarSesion.click();
    },
    iniciarSesion(cita) {
      this.loadingCal = true;
      this.listaPlanesPaciente = Array();
      
      this.citaSeleccionada = cita;
      this.citaSeleccionada.idPaciente = this.datosDetalle.idPaciente;
      this.listaOGCabecera = [];


      this.datosIniciarSesion = {
        herramientas: true,
        idPlan: undefined,
        idMotivoHerramienta: undefined,
        idKit: undefined,
      };

      this.validarTomaHerramientas();

      const parametros = {
        idClinica: this.citaSeleccionada.idClinica,
        especialidad: this.citaSeleccionada.idEspecialidadDoctor
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerListaDoctoresOGCabeceraClinica", parametros
          )
          .then((response) => {
            this.listaOGCabecera = response.data.data.map((it) => {
              const especialidades = it.especialidades
                  .map((esp) => esp.nombreEspecialidad)
                  .join(", ");
              return {
                id: it.idEmpleado,
                nombre:
                    it.numeroEmpleado +
                    " " +
                    it.nombreEmpleado +
                    " (" +
                    especialidades +
                    ")",
              };
            });
          })
          .catch((error) => {
            console.error(error);
          });
      const params = {
        idCita: this.citaSeleccionada.idCita
      }

      this.$http.post(this.$api + "planeacion/tomaHerramientas", params).then((response) => {
        const pacienteQuiereHerramientas = response.data.data;
        this.pacienteQuiereHerramientas = pacienteQuiereHerramientas;
        this.datosIniciarSesion.herramientas = !pacienteQuiereHerramientas ? pacienteQuiereHerramientas : true;


      })

      this.showDialogIniciarSession = true;
      this.loadingCal = false;
      this.loading = false;
    },
    async validarTomaHerramientas() {
      this.loadingExistePTI = true;
      this.noExistePTIVigente = true;
      const parametros = {idPaciente: this.citaSeleccionada.idPaciente}
      this.$http
          .post(
              this.$api +
              "pti/existePtiMayor6Meses", parametros
          )
          .then(async (response) => {

            await this.$http
                .post(
                    this.$api +
                    "pti/ptiSinHerramientas", parametros
                )
                .then((resp) => {
                  let sinHerramientas = resp.data.data
                  this.noExistePTIVigente = response.data.data && !sinHerramientas;
                  this.datosIniciarSesion.herramientas = this.noExistePTIVigente;
                })


          })
          .catch((error) => {
            console.error(
                "Error al obtener la validacion de existencia de un pti del  del paciente: " +
                error
            );
          })
          .finally(() => {
            this.loadingExistePTI = false;
            if (this.citaSeleccionada.especialistaNino) {
              this.datosIniciarSesion.herramientas = false;
            }
          });
    },
    iniciarSesionServ() {
      this.showDialogIniciarSession = false;
      this.datosIniciarSesion.citaSeleccionada = this.citaSeleccionada;
      this.iniciarSesion2();
    },
    iniciarSesion2() {
      const datosIniciarSesion = this.datosIniciarSesion;

      //para validar que no tenga mas de una cita hoy
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      this.loading = true;
      const data = {
        idCita: datosIniciarSesion.citaSeleccionada.idCita,
        idCompania: 1, //dentalia
        idClinica: this.datosBusqueda.clinica.clinicaID,
        idPaciente: datosIniciarSesion.citaSeleccionada.idPaciente,
        idEmpleado: datosIniciarSesion.citaSeleccionada.idDoctor,
        tomaHerramienta: datosIniciarSesion.herramientas,
        idMotivoHerramienta: datosIniciarSesion.idMotivoHerramienta,
        idPlan: datosIniciarSesion.idPlan,
        horaInicio: inicio,
        horaFin: fin,
        idKitDiagnostico: datosIniciarSesion.idKitDiagnostico,
        idOgCabecera: datosIniciarSesion.idOgCabecera,
      };
      this.$http
          .post(this.$api + "agenda/iniciarSesion", data)
          .then((response) => {
            if (response.status === 200) {
              if (!response.data.data) {
                this.$router.push("/dashboard");
              } else {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "El paciente ya cuenta con una sesión activa, no se puede crear otra nueva",
                });
              }
            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: error.response.data.message,
            });
          })
          .finally(() => (this.loading = false));
    },





    submitConfirmarCita() {
      const idCita = this.pacienteSeleccionado.idCita;
      this.loading = true;
      var params = {};
      if (this.listaConfirmarCita != null) {
        params = {
          idCita: idCita,
          idMotivoEspera: this.listaConfirmarCita.idMotivoEspera,
          comentario: this.listaConfirmarCita.comentario,
          usuarioModificacion: this.$localStorageService.getIdUsuario(),
        };
      } else {
        params = {
          idCita: idCita,
          idMotivoEspera: null,
          comentario: "",
          usuarioModificacion: this.$localStorageService.getIdUsuario(),
        };
      }

      this.loading = true;
      this.$http
          .put(this.$api + "cita/confirmar", params)
          .then((response) => {
            if (response.status === 200) {
              this.isCitaConfirmada = true;
              this.$swal.fire({
                icon: "success",
                title: "La cita se confirmo con éxito",
              });
              this.$bvModal.hide("modConfirmarCita");
              this.$emit('buscarAgenda')
              this.showDetail = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: error.response.data.message,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar la confirmación, contacte al administrador e intente nuevamente",
              });
            }

            this.loading = false;
          });
    },






    cancelarCita(cita) {
      this.llenarMotivosCancelacion();
      this.showDialogCancelarCita = true;
      this.datosCita = JSON.parse(JSON.stringify(cita));
      this.datosCancelarCita = {
        idCita: this.datosCita.idCita,
        idUsuario: this.$localStorageService.getIdUsuario(),
        motivoCancelacion: undefined,
        descripcionCancelacion: undefined,
      };
    },
    llenarMotivosCancelacion() {
      this.listaMotivosCancelacion = [];
      this.$http
          .get(this.$api + "catalogos/obtenerMotivosCancelacion")
          .then((response) => {
            if (response.status === 200) {
              this.listaMotivosCancelacion = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    submitCancelarCita() {
      if (this.datosCancelarCita.motivoCancelacion === 12) {
        /*    Se cancela si ...
        El paciente NO sea nuevo   -> this.datosDetalle.idSubtipoPaciente !== 1,
        La cita NO esté confirmada -> this.datosDetalle.idEstatusCita !== 2
        El PTI no sea mayor a 10k --> this.datosDetalle.montoPti < 10,000
        El tratamiento NO sea limpiezas o alguna resina -> 4, 11, 167, 168, 169, 170,
        El paciente no haya sido cancelado por este motivo en los ultimos 6 meses --> this.datosDetalle.cancelacionPriorizacionAntesDe6Meses = true
        */
        let puedeCancelar = false;
        if (this.datosDetalle.idSubTipoPaciente !== 1
            && this.datosDetalle.idEstatusCita !== 11

            && this.datosDetalle.tratamientos.filter(t => t.idTratamiento !== 4 && t.idTratamiento !== 11 &&
                                                     t.idTratamiento !==167 && t.idTratamiento !== 168
                                                     && t.idTratamiento !== 169 && t.idTratamiento !== 170 )
            && this.datosDetalle.cancelacionPriorizacionAntesDe6Meses !== true
            && this.datosDetalle.montoPti < 10000
        ) {

            this.listaTratamientosCita.forEach( t => {

                  if((t.idTratamiento !== 4 && t.idTratamiento !== 11 &&
                      t.idTratamiento !==167 && t.idTratamiento !== 168
                      && t.idTratamiento !== 169 && t.idTratamiento !== 170 )){

                    puedeCancelar = true;

                  }
            })

          }
        if (puedeCancelar) {

          this.$swal.fire({
            icon: "warning",
            html: '<strong><span>Se cancelará la cita y Se enviará a lista de espera</span></strong> <br>' +
                ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> ¿Desea configurar las opciones de cita</h5> <br> <h5 style="font-size: 12px;">manualmente?</h5>',
            confirmButtonText: "Si",
            confirmButtonColor: '#f19b51',
            cancelButtonText: "No",
            showLoaderOnConfirm: true,
            showCancelButton: true,
            closeOnClickOutside: false,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$emit('activarModalEspera', true)
            } else {
              this.$emit('llenarDatosListaEspera', false)
            }
          })

        } else {
          this.$swal.fire({
            icon: "error",
            html: '<strong><span>Paciente no candidato a cancelación</span></strong> <br>' +
                ' <br> <h5 style="font-size: 12px;margin-bottom: -20px;"> No es posible cancelar la cita a este </h5> <br> ' +
                '<h5 style="font-size: 12px;">paciente debido a su buen historial.</h5>',
            cancelButtonText: "Enterado",
            showCancelButton: true,
            showConfirmButton: false,
            closeOnClickOutside: false,
            allowOutsideClick: false,
          })

        }
      } else {
        this.$refs.submitCancelarCita.click();
      }
    },
    cancelarCitaServ() {
      const datosCancelarCita = this.datosCancelarCita;
      this.$http
          .put(
              this.$api +
              "cita/cancelar/id?" +
              "idCita=" +
              datosCancelarCita.idCita +
              "&idUsuario=" +
              datosCancelarCita.idUsuario +
              "&motivoCancelacion=" +
              datosCancelarCita.motivoCancelacion +
              "&descripcionCancelacion=" +
              datosCancelarCita.descripcionCancelacion
          )
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                icon: "success",
                title: "La cita se canceló con éxito",
              });

              this.$bvModal.hide("modCancelarCita");
              this.$emit('buscarAgenda')
              this.showDetail = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: error.response.data.message,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar la cancelación, contacte al administrador e intente nuevamente",
              });
            }

            this.loading = false;
          });
    },


    reagendarCita(cita){
      cita.tratamientosCita = this.listaTratamientosCita;
      this.$emit('reagendarCita', cita)
    },



    submitReasignarDoctor() {
      this.$refs.submitReasignarDoctor.click();
    },
    reasignarDoctor(cita) {
      this.datosFormularioReasignar = JSON.parse(JSON.stringify(cita));
      this.datosFormulario = JSON.parse(JSON.stringify(cita));

      this.listaDoctores = [];

      if (this.datosFormularioReasignar.citaSobreAsignada) {
        this.llenarDoctoresClinica(
            this.datosBusqueda.clinica.clinicaID
        ).then(() => (this.modalReasignarDoctor = true));
      } else if (this.datosFormularioReasignar.citaEmbajador) {
        this.llenarDoctoresEmbajadorClinica(
            this.datosBusqueda.clinica.clinicaID
        ).then(() => (this.modalReasignarDoctor = true));
      } else {
        this.llenarDoctoresClinica(this.datosBusqueda.clinica.clinicaID).then(
            () => (this.modalReasignarDoctor = true)
        );
      }
    },
    async llenarDoctoresClinica(idClinica) {
      if (idClinica === undefined || idClinica === null || idClinica === 0) {
        this.listaDoctores = Array();
        return;
      }

      if (
          this.datosFormulario.idPaciente === undefined ||
          this.datosFormulario.idPaciente == null ||
          this.datosFormulario.idPaciente === 0
      ) {
        return;
      }

      this.loadingDoctoresClinica = true;
      const parametros = {
        idClinica: idClinica,
        idPaciente: this.datosFormulario.idPaciente
      }
      this.$http
          .post(
              this.$api +
              "diagnostico/hoja/obtenerDoctoresClinicaPaciente", parametros
          )
          .then((response) => {
            if (response.status === 200) {
              this.listaDoctores = response.data.data
                  .map((it) => {
                    return {
                      id: it.idEmpleado,
                      nombre:
                          it.numeroEmpleado +
                          " " +
                          it.nombreEmpleado +
                          " (" +
                          this.obtenerEspecialidadesDoctor(it) +
                          ")",
                    };
                  })
                  .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
              this.listaDoctoresFiltro = this.listaDoctores;
            }
          })
          .catch((error) => {
            this.loadingDoctoresClinica = false;
            console.error(error);
          })
          .finally(() => {
            this.loadingDoctoresClinica = false;
          });
    },
    obtenerEspecialidadesDoctor(doctor) {
      if (
          doctor.especialidades != undefined &&
          doctor.especialidades !== null
      ) {
        return doctor.especialidades
            .map((esp) => esp.nombreEspecialidad)
            .join(", ");
      } else {
        return "-";
      }
    },
    guardarReasignarDoctor() {
      this.loading = true;
      const params = {
        idCita: this.datosFormularioReasignar.idCita,
        idDoctor: this.datosFormularioReasignar.idDoctor,
        citaAdministrativa: this.datosDetalle.citaAdministrativa
      }
      this.$http
          .put(
              this.$api +
              "agenda/reasignarCita",
              params
          )
          .then((response) => {
            this.loading = false;

            this.$swal.fire({
              icon: "success",
              title: response.data.message,
            });
            this.showDetail = false;
            this.modalReasignarDoctor = false;
            this.$emit('buscarAgenda')
          })
          .catch((error) => {
            if (error.response) {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: error.response.data.message,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar la confirmación, contacte al administrador e intente nuevamente",
              });
            }

            this.loading = false;
          });
    },

     cambiarConsultarDetallePorPaciente(pacienteSeleccionado) {
       const original = JSON.parse(JSON.stringify(this.datosDetalle));
       const overbooking = JSON.parse(JSON.stringify(this.datosDetalleOverbooking));
       this.pacienteSeleccionado.idCita = pacienteSeleccionado.idCita;
      
       this.datosDetalle = overbooking;
       this.datosDetalleOverbooking = original;
       this.$refs["tituloDetCita"].focus();
     },

    activarReasignarDoctor(cita) {
      const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined &&
          cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 ||
              cita.idEstatusCita === 11 ||
              cita.idEstatusCita === 24 ||
              cita.idEstatusCita === 26) &&
          this.$localStorageService.can("RD_01_reagendar_og");

      return (
          activar &&
          (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
              this.$moment() ||
              this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
              this.$moment())
      );
    },
    activarReagendar(cita) {
      const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined &&
          cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 ||
              cita.idEstatusCita === 11 ||
              cita.idEstatusCita === 24 ||
              cita.idEstatusCita === 26) &&
          this.$localStorageService.can("CA_06_reagendar_cita");

      return (
          activar &&
          (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
              this.$moment() ||
              this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
              this.$moment())
      );
    },
    activarCancelarCita(cita) {
      const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined &&
          cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 ||
              cita.idEstatusCita === 11 ||
              cita.idEstatusCita === 24 ||
              cita.idEstatusCita === 26) &&
          this.$localStorageService.can("CA_06_cancelar_cita");

      return (
          activar &&
          (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
              this.$moment() ||
              this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
              this.$moment())
      );
    },
    activarConfirmarCita(cita) {
      const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined &&
          cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 ||
              cita.idEstatusCita === 11 ||
              cita.idEstatusCita === 24 ||
              cita.idEstatusCita === 26) &&
          this.$localStorageService.can("CA_06_confirmar_cita");

      return (
          activar &&
          (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
              this.$moment() ||
              this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
              this.$moment())
      );
    },
    activarIniciarSesion(cita) {
      if (cita != null) {
        const activar =
            cita !== undefined &&
            cita !== null &&
            cita.idEstatusCita !== undefined &&
            cita.idEstatusCita !== null &&
            (cita.idEstatusCita === 5 ||
                cita.idEstatusCita === 11 ||
                cita.idEstatusCita === 24 ||
                cita.idEstatusCita === 26) &&
            this.$localStorageService.can("CA_6_iniciar_sesion");

        return (
            activar &&
            this.$moment(
                cita.fechaCitaSinZona + " " + cita.horaInicioCasilla
            ).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD")
        );
      }
    },
    activarSobreAgendar(cita) {
      if (this.datosDetalleOriginal!==undefined && this.datosDetalleOriginal !== null
          && this.datosDetalleOriginal.length>1) {
        return false;
      }

      const activar =
          cita !== undefined &&
          cita !== null &&
          cita.idEstatusCita !== undefined && cita.idEstatusCita !== null &&
          (cita.idEstatusCita === 5 || cita.idEstatusCita === 24 || cita.idEstatusCita === 11) &&
          this.$localStorageService.can("agenda_sobreagendar")
      ;

       return activar;
     },

     /**
      * Determina si una cita puede ser marcada como "sobre agendable" (overbooking),
      * según múltiples criterios relacionados con el estado de la cita, el canal de origen,
      * el perfil del paciente, permisos del usuario y la fecha/hora de la cita.
      *
      * @param {Object} cita - Objeto que representa la cita a evaluar.
      * @param {number} cita.saldoFavor - Saldo a favor del paciente.
      * @param {number} cita.idCanalOrigen - ID del canal por el que se originó la cita.
      * @param {number} cita.idEstatusCita - ID del estatus actual de la cita.
      * @param {boolean} cita.esPacienteVIP - Indica si el paciente es VIP.
      * @param {string} cita.fechaCitaSinZona - Fecha de la cita (sin zona horaria).
      * @param {string} cita.horaInicioCasilla - Hora de inicio de la cita.
      * @param {string} cita.horaFinCasilla - Hora de fin de la cita.
      *
      * @returns {boolean} `true` si la cita cumple con los criterios para ser marcada como sobre agendable,
      *                    `false` en caso contrario.
      *
      * Requisitos para validación:
      * - Saldo a favor menor o igual a 20,000.
      * - Canal de origen debe ser 3 o 5.
      * - Estatus de cita debe ser uno de: 1, 5, 11, 24.
      * - El paciente no debe ser VIP.
      * - El usuario debe tener permiso 'sobreAgendamiento' o 'overbooking_ger_flex'.
      * - La cita debe estar en el futuro (inicio o fin).
      * - Solo debe haber un detalle en `datosDetalleOriginal`.
      */

       pintarCitaSobreAgendable(cita){
       let validacion = (cita.saldoFavor <= 20000) &&
           (cita.idCanalOrigen === 3 || cita.idCanalOrigen === 5)
           && (cita.idEstatusCita === 1 || cita.idEstatusCita === 5 || cita.idEstatusCita === 11 || cita.idEstatusCita === 24)
           && !cita.esPacienteVIP
           && this.$localStorageService.can('sobreAgendamiento') &&
           (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
               this.$moment() ||
               this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
               this.$moment())  && this.datosDetalleOriginal.length === 1

       let validacionPerfilPermiso =
           (cita.idEstatusCita === 1 || cita.idEstatusCita === 5 || cita.idEstatusCita === 11 || cita.idEstatusCita === 24)
           && !cita.esPacienteVIP
           && this.$localStorageService.can('overbooking_ger_flex') &&
           (this.$moment(cita.fechaCitaSinZona + " " + cita.horaInicioCasilla) >=
               this.$moment() ||
               this.$moment(cita.fechaCitaSinZona + " " + cita.horaFinCasilla) >=
               this.$moment())  && this.datosDetalleOriginal.length === 1

       return validacion || validacionPerfilPermiso;
     },

     //------------Sobreagendar
     sobreAgendar(cita) {
         this.$emit('sobreAgendar', cita);
     },
     //------------Fin Sobreagendar

     //------------sobreAgendable
     sobreAgendable(cita) {
       this.$emit('sobreAgendable', cita);
     },
     //------------Fin sobreAgendable
     //------------sobreAgendable
     deshabilitarSobreAgendable(cita) {
       this.$emit('deshabilitarSobreAgendable', cita);
     },
     //------------Fin sobreAgendable


   }
}
</script>

<style scoped>
.flexbox {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 200px;
  border-radius: 1px 10px 10px 1px;
  color: #333;
}
.estatusHc {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 200px;
  border-radius: 10px 10px 10px 10px;
  color: #333;
}
.table th, .table td {
  padding: 0.75rem;
  padding: 0.2rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  font-size: 11px;
}
.iconAgendaDetalle{
  width: 3%;
  margin-bottom: -7px;
  filter: invert(33%) sepia(36%) saturate(825%) hue-rotate(154deg) brightness(86%) contrast(105%);
}
.text-small{
  font-size: 12px !important;
}

.filtrosCita{
  font-size: 11px;
  color: #0069aa;
}

/*.tresPuntitos{
  position: absolute;
  margin-left: 76%;
  cursor: pointer;
  margin-top: 80px;
  z-index: 1;
}*/


</style>

<style>
.validacioneslist li {
  list-style: disc !important;
}
</style>
